module.exports = __webpack_public_path__ + "static/media/epiq_favicon.77ce0299.ico";